/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable import/prefer-default-export */
import mirror from 'keymirror';
import debounce from 'debounce-async';
import Progress from '../lib/progress';

export const actionTypes = mirror({
  PROGRESS_GET: null,
  PROGRESS_GET_COUNTS: null,
  PROGRESS_GET_RECENT: null,
  PROGRESS_GET_RECENTLY_VIEWED: null,
  PROGRESS_GET_LEVELS_COMPLETED: null,
  PATHS_PROGRESS_UPDATED: null,
  COURSES_PROGRESS_UPDATED: null,
  COURSES_COMPLETED_UPDATED: null,
  LESSONS_PROGRESS_UPDATED: null,
  COMPLETED_LESSONS_UPDATED: null,
  PROGRESS_GET_ERROR: null,
  PROGRESS_IN_PROGRESS: null,
  PROGRESS_UPDATE_ERROR: null,
  FC_SIGNOUT: null,
  SET_LEVEL: null,
  STAND_ALONE_LESSON_PROGRESS_UPDATE: null,
});

const progressInProgress = (): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_IN_PROGRESS,
  };
};

const getProgress = (progress: any): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_GET,
    progress,
  };
};

const getProgressLevelsCompletedUpdated = (completed: any): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_GET_LEVELS_COMPLETED,
    completed,
  };
};

const getProgressCountsUpdated = (counts: any): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_GET_COUNTS,
    counts,
  };
};

const getProgressRecentUpdated = (recent: any): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_GET_RECENT,
    recent,
  };
};

const getRecentlyViewedUpdated = (recentlyViewed: any): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_GET_RECENTLY_VIEWED,
    recentlyViewed,
  };
};

const getProgressError = (error: any): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_GET_ERROR,
    error,
  };
};

const pathsProgressUpdated = (
  pathID: string,
  playlistID: string,
  courseID: string,
  lessonID: string,
  style: string,
  instrument: string,
  courseType: string,
  lessonType: string,
): Record<any, unknown> => {
  return {
    type: actionTypes.PATHS_PROGRESS_UPDATED,
    pathID,
    playlistID,
    courseID,
    lessonID,
    style,
    instrument,
    courseType,
    lessonType,
  };
};

const coursesProgressUpdated = (
  courseID: string,
  lessonID: string,
  courseType: string,
  lessonType: string,
): Record<any, unknown> => {
  return {
    type: actionTypes.COURSES_PROGRESS_UPDATED,
    courseID,
    lessonID,
    courseType,
    lessonType,
  };
};

export const coursesCompletedUpdated = ({
  courseId,
  completed,
}: {
  courseId: string;
  completed: any;
}): Record<any, unknown> => {
  return {
    type: actionTypes.COURSES_COMPLETED_UPDATED,
    courseId,
    completed,
  };
};

const standAloneLessonProgressUpdate = (
  lessonID: string,
  lessonType: string,
): Record<any, unknown> => {
  return {
    type: actionTypes.STAND_ALONE_LESSON_PROGRESS_UPDATE,
    lessonID,
    lessonType,
  };
};

const lessonsProgressUpdated = (
  lessonID: string,
  lessonType: string,
  videoWatchedSeconds = 0,
  completed = false,
): Record<any, unknown> => {
  return {
    type: actionTypes.LESSONS_PROGRESS_UPDATED,
    lessonID,
    lessonType,
    videoWatchedSeconds,
    completed,
  };
};

const completedLessonsUpdated = (options: any): Record<any, unknown> => {
  return {
    type: actionTypes.COMPLETED_LESSONS_UPDATED,
    options,
  };
};

const progressUpdateError = (error: any): Record<any, unknown> => {
  return {
    type: actionTypes.PROGRESS_UPDATE_ERROR,
    error,
  };
};

const updateRecentLevel = (level: any): Record<any, unknown> => {
  return {
    type: actionTypes.SET_LEVEL,
    level,
  };
};

export const requestProgress = async (
  listOfID: any,
  type: string,
  dispatch: any,
): Promise<void> => {
  try {
    dispatch(progressInProgress());
    let progress = null;
    if (type === 'lessons') {
      progress = await Progress.getLessons(listOfID);
    } else if (type === 'courses') {
      progress = await Progress.getCourses(listOfID);
    } else {
      progress = await Progress.getPath(listOfID);
    }
    dispatch(getProgress(progress));
  } catch (err) {
    dispatch(getProgressError(err));
  }
};

export const getProgressLevelsCompleted = (pathArr: any) => {
  return async (dispatch: any): Promise<void> => {
    try {
      dispatch(progressInProgress());
      const completed = await Progress.getProgressLevelsCompleted(pathArr);
      dispatch(getProgressLevelsCompletedUpdated(completed));
    } catch (err) {
      dispatch(getProgressError(err));
    }
  };
};

export const getProgressCounts = (progressArr: any) => {
  // eslint-disable-line
  return async (dispatch: any): Promise<void> => {
    try {
      dispatch(progressInProgress());
      const counts = await Progress.getProgressCounts(progressArr);
      dispatch(getProgressCountsUpdated(counts));
    } catch (err) {
      dispatch(getProgressError(err));
    }
  };
};

export const getProgressRecent = (
  lessons: any,
  exercises: any,
  songs: any,
  chords: any,
  riffs: any,
) => {
  return async (dispatch: any): Promise<void> => {
    try {
      dispatch(progressInProgress());
      const counts = await Progress.getProgressRecent(lessons, exercises, songs, chords, riffs);
      dispatch(getProgressRecentUpdated(counts));
    } catch (err) {
      dispatch(getProgressError(err));
    }
  };
};

export const getRecentlyViewed = (count: any) => {
  return async (dispatch: any): Promise<void> => {
    try {
      dispatch(progressInProgress());
      const counts = await Progress.getRecentlyViewed(count);
      dispatch(getRecentlyViewedUpdated(counts['recently-viewed'] || []));
    } catch (err) {
      dispatch(getProgressError(err));
    }
  };
};

export const getCoursesProgress = (listOfID: any) => {
  return async (dispatch: any): Promise<void> => {
    try {
      dispatch(progressInProgress());
      const progress = await Progress.getCourses(listOfID);
      dispatch(getProgress(progress));
    } catch (err) {
      dispatch(getProgressError(err));
    }
  };
};

export const getLessonsProgress = (listOfID: any) => {
  return async (dispatch: any): Promise<void> => {
    try {
      dispatch(progressInProgress());
      const progress = await Progress.getLessons(listOfID);
      dispatch(getProgress(progress));
    } catch (err) {
      dispatch(getProgressError(err));
    }
  };
};

export const updatePathProgress = (
  pathID: string,
  playlistID: string,
  courseID: string,
  lessonID: string,
  style: string,
  instrument: string,
  courseType: string,
  lessonType: string,
): any => {
  const pathUpdate = async (dispatch: any): Promise<void> => {
    try {
      const paths = [
        Progress.mapUpdatePathPayload(
          pathID,
          playlistID,
          courseID,
          lessonID,
          style,
          instrument,
          courseType,
          lessonType,
        ),
      ];
      await Progress.updatePath(paths);
      dispatch(
        pathsProgressUpdated(
          pathID,
          playlistID,
          courseID,
          lessonID,
          style,
          instrument,
          courseType,
          lessonType,
        ),
      );
    } catch (err) {
      dispatch(progressUpdateError(err));
    }
  };
  return debounce(pathUpdate, 3000);
};

export const updateCourseProgress = (
  courseID: string,
  lessonID: string,
  courseType: string,
  lessonType: string,
  instrument = 'guitar',
) => {
  return async (dispatch: any): Promise<void> => {
    try {
      const courses = [
        Progress.mapUpdateCoursePayload(courseID, lessonID, courseType, lessonType, instrument),
      ];
      await Progress.updateCourse(courses);
      dispatch(coursesProgressUpdated(courseID, lessonID, courseType, lessonType));
    } catch (err) {
      dispatch(progressUpdateError(err));
    }
  };
};

export function updateLessonProgress(
  lessonID: string,
  lessonType: string,
  videoWatchedSeconds: any,
  instrument = 'guitar',
  videoTotalSeconds: any,
) {
  return async (dispatch: any): Promise<void> => {
    try {
      const percentCompleted = Math.round((videoWatchedSeconds / videoTotalSeconds) * 100);
      const lessons = [
        Progress.mapUpdateLessonPayload(
          lessonID,
          lessonType,
          videoWatchedSeconds,
          percentCompleted,
          instrument,
        ),
      ];
      await Progress.updateLesson(lessons);
      dispatch(
        lessonsProgressUpdated(lessonID, lessonType, videoWatchedSeconds, videoWatchedSeconds),
      );
    } catch (err) {
      dispatch(progressUpdateError(err));
    }
  };
}

export const updateLessonStandaloneProgress = (lessonID: string, lessonType: string) => {
  return async (dispatch: any): Promise<void> => {
    try {
      await Progress.updateLessonStandalone(lessonID, lessonType);
      dispatch(standAloneLessonProgressUpdate(lessonID, lessonType));
    } catch (err) {
      dispatch(progressUpdateError(err));
    }
  };
};

export const updateLessonCompletedProgress = (lessons: any, courseData: any) => {
  return async (dispatch: any): Promise<void> => {
    try {
      if (courseData) dispatch(coursesCompletedUpdated(courseData));
      dispatch(completedLessonsUpdated(lessons));
      await Progress.updateLessonCompletedProgress(lessons);
    } catch (err) {
      dispatch(progressUpdateError(err));
    }
  };
};

export const updateLevel = (level: any) => {
  return async (dispatch: any): Promise<void> => {
    dispatch(updateRecentLevel(level));
  };
};
